import { DEMO_HOSTNAME } from "../../../_app/router/utils/isComponentLibraryEnabled";

export const shouldShowJsonViewer = () => {
  return (
    process.env.NODE_ENV !== "production" &&
    process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" &&
    process.env.REACT_APP_SERVER !== "PRODUCTION" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname.includes("staging") ||
      window.location.hostname.includes("dev") ||
      window.location.hostname.includes("127.0.0.1"))
  );
};

// Same dev-only gate, for the Component Library nav item - see
// isComponentLibraryEnabled.js's own comment. Also shown on the demo site; the
// JSON viewer stays dev-only.
export const shouldShowComponentLibrary = () =>
  shouldShowJsonViewer() ||
  (process.env.REACT_APP_ENVIRONMENT !== "PRODUCTION" &&
    process.env.REACT_APP_SERVER !== "PRODUCTION" &&
    window.location.hostname === DEMO_HOSTNAME);
